// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    background-color: white;
    box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
}

.footer-pagination {
    display: flex;
    justify-content: center;
}

.footer-pagination-ul {
    justify-content: center;
}

.footer-pagination .MuiPaginationItem-root {
    background-color: white;
}

.footer-pagination .MuiPaginationItem-root:hover {
    background-color: #f5f5f5;
}

.footer-pagination .MuiPaginationItem-root.Mui-selected {
    background-color: white;
    position: relative;
}

.footer-pagination .MuiPaginationItem-root.Mui-selected::after {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0 auto;
    width: 70%;
    height: 3px;
    background-color: #394E9E;
}

.footer-pagination .MuiPaginationItem-root.Mui-selected:hover {
    background-color: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./src/components/footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".footer-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 12px 24px;\n    background-color: white;\n    box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.footer-pagination {\n    display: flex;\n    justify-content: center;\n}\n\n.footer-pagination-ul {\n    justify-content: center;\n}\n\n.footer-pagination .MuiPaginationItem-root {\n    background-color: white;\n}\n\n.footer-pagination .MuiPaginationItem-root:hover {\n    background-color: #f5f5f5;\n}\n\n.footer-pagination .MuiPaginationItem-root.Mui-selected {\n    background-color: white;\n    position: relative;\n}\n\n.footer-pagination .MuiPaginationItem-root.Mui-selected::after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: 0 auto;\n    width: 70%;\n    height: 3px;\n    background-color: #394E9E;\n}\n\n.footer-pagination .MuiPaginationItem-root.Mui-selected:hover {\n    background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
